import {Modal} from 'bootstrap';
import RequestHelper from '../helpers/request-helper';

const requestHelper = new RequestHelper();

const shelterHeaderTemplate = require('../twigs/shelters/shelterHeaderTemplate.twig');
const shelterBioTemplate = require('../twigs/shelters/shelterBioTemplate.twig');
const shelterGoalTemplate = require('../twigs/shelters/shelterGoalTemplate.twig');
const donatePointsModalTemplate = require('../twigs/donatePointsModalTemplate.twig');
const donationConfirmationModalTemplate = require('../twigs/donationConfirmationModalTemplate.twig');

export default class ShelterDetail {
    constructor() {
        this.modalContainer = document.getElementById('modal-container');

        this.state = {
            shelterID: Electro.shelterID,
            isShelter: FreshStep.isShelter,
            shelter: null,
            activeGoal: null,
            balance: 0,
        };

        this.render();
    }

    initListeners() {
        $('.js-donate-points').on('click', (e) => {
            e.preventDefault();

            this.renderDonatePointsModal();
        });
    }

    fetchShelterDetail() {
        requestHelper
            .makeRequest(`/wp-json/electro/v1/paw-points/shelter/${this.state.shelterID}`, 'GET')
                .then((response) => {
                    this.state.shelter = response.data;

                    if (this.state.shelter.goals) {
                        this.state.shelter.goals.forEach((item) => {
                            if (item.active) {
                                this.state.activeGoal = item;
                            }
                        });
                    }

                    this.renderShelterHeader();
                    this.renderShelterBio();
                    this.renderShelterGoal();
                    this.initListeners();
                }
            );
    }

    fetchPointBalance() {
        requestHelper
            .makeAuthenticatedRequest('/wp-json/electro/v1/paw-points/user-points-total', 'POST')
            .then((response) => {
                this.state.balance = response.data;

                this.fetchShelterDetail();
            });
    }

    runCalculator() {
        $('.js-point-balance').html(this.state.balance);

        if (this.state.activeGoal.pointsAchieved >= this.state.activeGoal.pointsTarget) {
            $('.js-goal-progress').css('width', '100%');
        } else {
            const percentage = (this.state.activeGoal.pointsAchieved / this.state.activeGoal.pointsTarget) * 100;

            $('.js-goal-progress').css('width', `${percentage}%`);
        }
    }

    donatePoints(value) {
        requestHelper
            .makeAuthenticatedRequest(`/wp-json/electro/v1/paw-points/shelter/${this.state.shelterID}/donate`, 'POST', {
                points: value,
            })
            .then((response) => {
                if (response.status === 0) {
                    this.state.balance = response.data.newFromMemberPointsBalance;
                    $('.js-point-balance').html(this.state.balance);
                    this.renderDonationConfirmationModal();
                } else {
                    return false;
                }

                return true;
            });
    }

    renderDonationConfirmationModal() {
        $(this.modalContainer).html(
            donationConfirmationModalTemplate({})
        );
    }

    renderDonatePointsModal() {
        $(this.modalContainer).html(
            donatePointsModalTemplate({
                balance: this.state.balance,
            })
        );

        const donatePointsModal = new Modal(this.modalContainer);
        donatePointsModal.show();

        const parsleyConfig = {
            errorsContainer(pEle) {
                return pEle.$element.siblings('#donate-form .error__wrapper');
            },
        };

        $('#donate-form').parsley(parsleyConfig);

        const specificField = $('#donate-form input:text').parsley();

        $('.js-confirm-donation')
            .off()
            .on('click', (e) => {
                e.preventDefault();

                let $value = null;
                $('.js-confirm-donation').prop('disabled', true);

                if ($('#donate-form input:radio').is(':checked')) {
                    $value = $('#donate-form input:checked').val();
                    this.donatePoints($value);
                } else if ($('#donate-form').parsley().validate()) {
                    $value = $('#donate-form input:text').val();

                    if ($value < 100) {
                        window.ParsleyUI.addError(
                            specificField,
                            'lessThan100',
                            'Oops, you need at least 100 points in your account to donate.'
                        );
                    } else if ($value > this.state.balance) {
                        window.ParsleyUI.addError(
                            specificField,
                            'moreThanBalance',
                            'Oops, you can not donate more points than you currently have.'
                        );
                    } else {
                        this.donatePoints($value);
                    }
                }
            });

        $('#donate-form input:text')
            .off()
            .on('input', () => {
                $('#donate-form input:radio').prop('checked', false);
                $('.js-confirm-donation').prop('disabled', false);
                window.ParsleyUI.removeError(specificField, 'lessThan100');
                window.ParsleyUI.removeError(specificField, 'moreThanBalance');
            });

        $('#donate-form input:radio')
            .off()
            .on('click', () => {
                $('#donate-form input:text').val('');
                $('.js-confirm-donation').prop('disabled', false);
                window.ParsleyUI.removeError(specificField, 'lessThan100');
                window.ParsleyUI.removeError(specificField, 'moreThanBalance');
            });
    }

    renderShelterHeader() {
        $('#shelter-header').append(
            shelterHeaderTemplate({
                shelter: this.state.shelter,
                user: FreshStep.LOGGED_IN,
                balance: this.state.balance,
                isShelter: this.state.isShelter,
            })
        );
    }

    renderShelterBio() {
        $('#shelter-bio').append(
            shelterBioTemplate({
                shelter: this.state.shelter,
                user: FreshStep.LOGGED_IN,
                balance: this.state.balance,
                isShelter: this.state.isShelter,
            })
        );
    }

    renderShelterGoal() {
        $('#shelter-goal').append(
            shelterGoalTemplate({
                shelter: this.state.shelter,
                activeGoal: this.state.activeGoal,
                user: FreshStep.LOGGED_IN,
                balance: this.state.balance,
                isShelter: this.state.isShelter,
            })
        );

        if (this.state.activeGoal) {
            this.runCalculator();
        }
    }

    async render() {
        if (FreshStep.LOGGED_IN) {
            await this.fetchPointBalance();
        } else {
            this.fetchShelterDetail();
        }
    }
}
